import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.schedulesDefinition],
        config: {
            headerName: getLocalizedString("scheduleCodeShort"),
            field: "code",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.schedulesDefinition],
        config: {
            headerName: getLocalizedString("scheduleName"),
            field: "name",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.schedulesDefinition],
        config: {
            headerName: getLocalizedString("scheduleGroup"),
            field: "group",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.schedulesDefinition],
        config: {
            headerName: getLocalizedString("scheduledTime"),
            field: "isProgrammableString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.schedulesDefinition],
        config: {
            headerName: getLocalizedString("scheduledEntry"),
            field: "entryProg",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.schedulesDefinition],
        config: {
            headerName: getLocalizedString("scheduledExit"),
            field: "exitProg",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.schedulesDefinition],
        config: {
            headerName: getLocalizedString("totalShiftHours"),
            field: "totalHours",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.schedulesDefinition],
        config: {
            headerName: getLocalizedString("scheduledBreak"),
            field: "breakProgString",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.schedulesDefinition],
        config: {
            headerName: getLocalizedString("scheduledBreakStart"),
            field: "breakStart",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.schedulesDefinition],
        config: {
            headerName: getLocalizedString("endOfScheduledBreak"),
            field: "breakEnd",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.schedulesDefinition],
        config: {
            headerName: getLocalizedString("breakTime"),
            field: "timeBreak",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.schedulesDefinition],
        config: {
            headerName: getLocalizedString("netShiftHours"),
            field: "netHours",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.schedulesDefinition],
        config: {
            headerName: getLocalizedString("entryDelayTolerance"),
            field: "entryTolerance",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.schedulesDefinition],
        config: {
            headerName: getLocalizedString("overtimeTolerance"),
            field: "additionalsTolerance",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.schedulesDefinition],
        config: {
            headerName: getLocalizedString("abbreviatedSchedule"),
            field: "abrev",
            filter: "agTextColumnFilter",
        }
    },
]